module.exports = __webpack_public_path__ + "img/CM-EC-24-Acura-Modern.4e84550f.jpg";